var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Confirm',{on:{"confirmed":function($event){return _vm.deleteSample()}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"loading":_vm.loading,"disabled":_vm.loading || _vm.sample.qa_approved || _vm.sample.released,"color":"error","small":"","tile":""}},on),[_vm._v("DELETE")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }